import { Field } from 'react-final-form';
import { useExperimentFlag } from '../../../../utils/useExperimentFlag';
import { useTranslation } from '../../../../utils/useTranslation';
import { makeSocialLinksValidator } from '../../../../utils/validators/makeSocialLinksValidator';
import { Typography } from '../../../typography/Typography';
import { BusinessType } from '../../types';
import {
    textDictionary,
    validateInstagram,
    validateInstagramRequired,
    validateTelegram,
    validateVk,
} from '../constants';
import { LinkField } from './LinkField';

export interface SocialLinkFieldsProps {
    businessType: BusinessType;
    onFieldBlur: (name: string, value: string) => void;
    requireAtLeastOne?: boolean;
}

export const SocialLinkFields = ({
    businessType,
    onFieldBlur,
    requireAtLeastOne = false,
}: SocialLinkFieldsProps) => {
    const t = useTranslation();
    const textMap = textDictionary[businessType];
    const isBlogger = businessType === BusinessType.BLOGGER;
    const isInstagramRequired = Number(useExperimentFlag('business_registration_v2')) !== 1;

    return (
        <>
            {requireAtLeastOne ? (
                <Typography variant="body" pb={1}>
                    {t(
                        'Для создания аккаунта, необходимо предоставить информацию хотя бы об одном из существующих аккаунтов в социальных сетях.',
                    )}
                </Typography>
            ) : null}
            {isBlogger || isInstagramRequired ? (
                <Typography variant="body" pb={1}>
                    {t('Если у вас нет возможности заполнить все обязательные поля, заполните ')}
                    <Typography
                        as="a"
                        display="inline"
                        href="https://forms.yandex.ru/surveys/13583098.c6d3daeb799a9937ad8e90ed8f79c1ab090651d8/"
                        variant="body"
                        color="link"
                        target="_blank"
                    >
                        {t('форму')}
                    </Typography>
                    <Typography variant="body" pt={1} display="inline">
                        {t(', чтобы следить за их изменениями.')}
                    </Typography>
                </Typography>
            ) : (
                <Typography variant="body" pb={1}>
                    {t(
                        'Не забудьте указать ссылки на соцсети вашего бизнеса. Это поможет нам лучше узнать о вашей компании и повысит качество взаимодействия с аудиторией.',
                    )}
                </Typography>
            )}
            {/* Скрытое поле для валидации социальных сетей */}
            {requireAtLeastOne ? (
                <Field
                    name="socialLinksValidation"
                    validate={makeSocialLinksValidator()}
                    subscription={{ value: true, error: true, touched: true }}
                    render={() => null}
                />
            ) : null}
            <LinkField
                name="instagramUrl"
                validate={isInstagramRequired ? validateInstagramRequired : validateInstagram}
                required={isInstagramRequired}
                label={t(textMap.instagramLink)}
                placeholder="https://www.instagram.com/username"
                onFieldBlur={onFieldBlur}
            />
            <LinkField
                name="telegramUrl"
                label={t(textMap.telegramLink)}
                validate={validateTelegram}
                placeholder="https://t.me/username"
                onFieldBlur={onFieldBlur}
            />
            <LinkField
                name="vkUrl"
                validate={validateVk}
                label={t('ВКонтакте')}
                placeholder="https://vk.com/username"
                onFieldBlur={onFieldBlur}
            />
        </>
    );
};
